import co from 'co'
import api from '../../libs/Api'
import constants from '../../constants'
import * as types from './types'

function genOfficeSlotName (officeId) {
  return `officeId:${officeId}`
}

export default {
  namespaced: true,
  state: {
    selectedOfficeId: null,
    staffsList: [],
    usersList: [],
    selectedStaffsList: []
  },
  mutations: {
    [types.SET_SELECTED_OFFICE_ID] (state, value) {
      state.selectedOfficeId = value
    },
    [types.CLEAR_STAFF_LIST] (state) {
      state.staffsList = []
    },
    [types.SET_STAFFS_LIST] (state, { key, value }) {
      if (!state.staffsList) state.staffsList = {}
      state.staffsList[key] = value
    },
    [types.CLEAR_USERS_LIST] (state) {
      state.usersList = []
    },
    [types.SET_USERS_LIST] (state, { key, value }) {
      if (!state.usersList) state.usersList = {}
      state.usersList[key] = value
    },
    [types.SET_SELECTED_STAFFS_LIST] (state, value) {
      state.selectedStaffsList = value
    }
  },
  actions: {
    initStaffShift ({ commit }) {
      commit(types.CLEAR_STAFF_LIST)
      commit(types.CLEAR_USERS_LIST)
    },
    setSelectedStaffs ({ commit, state }, { officeId, staffs }) {
      commit(types.SET_SELECTED_STAFFS_LIST, staffs)
    },
    loadUsers ({ commit, state }, { officeId, userViewMode }) {
      return co(function * () {
        const slotName = genOfficeSlotName(officeId)
        const users = yield api.getUser(constants.QUERY_MODE_TRIM_GET, null, officeId, userViewMode)
        console.info(users)
        commit(types.SET_USERS_LIST, { key: slotName, value: users })
      })
    },
    selectOffice ({ commit, state }, { officeId, userViewMode }) {
      if (!officeId) {
        return Promise.resolve([])
      }
      return co(function * () {
        const slotName = genOfficeSlotName(officeId)

        let staffs = state.staffsList[slotName]
        if (!staffs) {
          staffs = yield api.getStaffs(constants.QUERY_MODE_TRIM_GET, null, officeId)
        }
        if (officeId !== state.selectedOfficeId) {
          commit(types.SET_SELECTED_STAFFS_LIST, [])
        }
        commit(types.SET_SELECTED_OFFICE_ID, officeId)
        commit(types.SET_STAFFS_LIST, { key: slotName, value: staffs })
        //
        let users = state.usersList[slotName]
        if (!users) {
          users = yield api.getUser(constants.QUERY_MODE_TRIM_GET, null, officeId, userViewMode)
        }
        commit(types.SET_USERS_LIST, { key: slotName, value: users })
      })
    }
  },
  getters: {
    users: (state) => {
      if (!state.selectedOfficeId) return []
      const slotName = genOfficeSlotName(state.selectedOfficeId)
      return state.usersList[slotName] || []
    },
    staffs: (state) => {
      if (!state.selectedOfficeId) return []
      const slotName = genOfficeSlotName(state.selectedOfficeId)
      return state.staffsList[slotName] || []
    },
    selectedStaffs: (state) => {
      return state.selectedStaffsList || []
    }
  }
}
